import { useEffect, useState } from 'react'

export default function useTextAnimation(
  text: any,
  setFadeOut: (b: boolean) => void,
  setContent: (s: string) => void,
  state: number,
) {
  const [delay, setDelay] = useState<number>(200)
  useEffect(() => {
    switch (state) {
      case 4:
        setDelay(2100)
        break
      case 5:
      case 6:
      case 11:
        setDelay(1500)
        break
      default:
        setDelay(200)
        break
    }
  }, [state])

  useEffect(() => {
    setFadeOut(true)
    const timeout: ReturnType<typeof setTimeout> = setTimeout(() => {
      clearTimeout(timeout)
      setContent(text)
      setFadeOut(false)
    }, delay)
    return () => {
      clearTimeout(timeout)
    }
  }, [text, delay, setContent, setFadeOut])
  return text
}
